module.exports = __webpack_public_path__ + "media/src/videos/hero-video-1181b7cf44946538427f3abd48ce5343.webm";